import React from 'react';

import { XAxis, YAxis, Tooltip } from 'recharts';
import { LineChart as ReactLineChart, Line, ResponsiveContainer } from 'recharts';

// ROY G BIV
const colors = [
  '#dc3545',
  '#fd7e14',
  '#ffc107',
  '#198754',
  '#0d6efd',
  '#6610f2',
  '#6f42c1',
  '#d63384',
  '#20c997',
  '#0dcaf0',
  '#6c757d',
  '#212529'
];

const LineChart = ({ data, xAxisLabel, yAxisLabel, xField, dataFields = ['value'], xAxisLabelFormatter, ticks }) => (
  <div style={{ width: '100%', height: 300 }}>
    <ResponsiveContainer>
      <ReactLineChart
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5
        }}
      >
        <XAxis
          dataKey={xField}
          type="number"
          label={{ value: xAxisLabel, position: 'insideBottom' }}
          domain={['dataMin', 'dataMax']}
          tickFormatter={xAxisLabelFormatter}
          ticks={ticks}
          tick={true}
        />
        <YAxis type="number" label={{ value: yAxisLabel, angle: -90, position: 'insideLeft' }} />
        <Tooltip labelFormatter={xAxisLabelFormatter} />
        {dataFields.map((f, index) => (
          <Line key={index} dataKey={f} stackId="a" stroke={colors[index]} dot={false} />
        ))}
      </ReactLineChart>
    </ResponsiveContainer>
  </div>
);

export default LineChart;
